module.exports = __webpack_public_path__ + "static/media/homeMobile.eb6901d0.jpg";